import { motion, AnimatePresence } from 'framer-motion'
import { getNumberColor } from '../utils/ruletaLogic'
import { cn } from '@/lib/utils'

interface LastNumbersProps {
  numbers: number[]
}

export function LastNumbers({ numbers }: LastNumbersProps) {
  if (numbers.length === 0) return null

  return (
    <div className="flex flex-col items-center gap-2">
      <span className="text-casino-gold/60 font-cinzel text-xs tracking-wider">
        ÚLTIMOS NÚMEROS
      </span>
      <div className="flex gap-1 flex-wrap justify-center">
        <AnimatePresence mode="popLayout">
          {numbers.map((num, index) => {
            const color = getNumberColor(num)
            return (
              <motion.div
                key={`${num}-${index}`}
                initial={{ scale: 0, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0, opacity: 0 }}
                layout
                className={cn(
                  'w-8 h-8 rounded-full flex items-center justify-center',
                  'text-sm font-bold text-white shadow-md',
                  'border border-casino-gold/30',
                  color === 'red' && 'bg-red-700',
                  color === 'black' && 'bg-gray-900',
                  color === 'green' && 'bg-green-700',
                  index === 0 && 'ring-2 ring-casino-gold'
                )}
              >
                {num}
              </motion.div>
            )
          })}
        </AnimatePresence>
      </div>

      {/* Statistics */}
      {numbers.length >= 3 && (
        <div className="flex gap-4 text-xs text-gray-400 mt-1">
          <span>
            Rojo: {numbers.filter((n) => getNumberColor(n) === 'red').length}
          </span>
          <span>
            Negro: {numbers.filter((n) => getNumberColor(n) === 'black').length}
          </span>
          <span>
            Verde: {numbers.filter((n) => getNumberColor(n) === 'green').length}
          </span>
        </div>
      )}
    </div>
  )
}
